import React, { forwardRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './_button-sort.scss'
import './_button-sort.dark-mode.scss'

import { UI_NAME } from '../../../utils/config';

const ButtonSort = forwardRef(
  ({ sortBy, children, ...rest }, ref) => (
    <button
      {...rest}
      ref={ref}
      className={classNames(`${UI_NAME}-button__sort`, {
        [`${UI_NAME}-button__sort--desc`]: sortBy === 'desc',
        [`${UI_NAME}-button__sort--asc`]: sortBy === 'asc',
        [`${UI_NAME}-button__sort--default`]: !sortBy,
      })}
    >
      {children}
    </button>
  ),
);

ButtonSort.propTypes = {
  children: PropTypes.node,
  sortBy: PropTypes.oneOf(['asc', 'desc', null]),
};

ButtonSort.defaultProps = {
  sortBy: null,
  children: null,
};

export default ButtonSort;
